module.exports = __webpack_public_path__ + "img/ico_folder--bl.551b4376.svg";